export enum InventoryCustomViewKey {
  applicationsRecentlyModified = 'applicationsRecentlyModified',
  automationsRecentlyModified = 'automationsRecentlyModified',
  newUsersCreation = 'newUsersCreation',
  externalIdentities = 'externalIdentities',
  connectionCreatedFromCustomConnector = 'connectionCreatedFromCustomConnector',
  notInUseConnection = 'notInUseConnection',
  disabledConnections = 'disabledConnections',
  disabledAutomations = 'disabledAutomations',
  inactiveUsers = 'inactiveUsers',
  automationUsesAiModel = 'automationUsesAiModel',
  teamsEnvironments = 'teamsEnvironments',
  autonomousAgents = 'autonomousAgents',
  declarativeAgents = 'declarativeAgents',
  agentsUsingMcp = 'agentsUsingMcp',
  automationUsesWebhook = 'automationUsesWebhook',
  automationUsesHttpStepsWithoutAuthentication = 'automationUsesHttpStepsWithoutAuthentication',
  agentTriggers = 'agentTriggers',
  allBuilders = 'isBuilder',
  orgWideAccess = 'orgWideAccess',
  publicAccess = 'publicAccess',
  shadowAi = 'shadowAi',
  privilegedAgents = 'privilegedAgents',
}

export const InventoryCustomViewFields: {
  [key in InventoryCustomViewKey]: string;
} = {
  [InventoryCustomViewKey.applicationsRecentlyModified]:
    'tableActionsAndFilters.inventoryCustomViewDetails.applicationsRecentlyModified',
  [InventoryCustomViewKey.automationsRecentlyModified]:
    'tableActionsAndFilters.inventoryCustomViewDetails.automationsRecentlyModified',
  [InventoryCustomViewKey.newUsersCreation]: 'tableActionsAndFilters.inventoryCustomViewDetails.newUsersCreation',
  [InventoryCustomViewKey.externalIdentities]: 'tableActionsAndFilters.inventoryCustomViewDetails.externalIdentities',
  [InventoryCustomViewKey.connectionCreatedFromCustomConnector]:
    'tableActionsAndFilters.inventoryCustomViewDetails.connectionCreatedFromCustomConnector',
  [InventoryCustomViewKey.notInUseConnection]: 'tableActionsAndFilters.inventoryCustomViewDetails.notInUseConnection',
  [InventoryCustomViewKey.disabledConnections]: 'tableActionsAndFilters.inventoryCustomViewDetails.disabledConnections',
  [InventoryCustomViewKey.disabledAutomations]: 'tableActionsAndFilters.inventoryCustomViewDetails.disabledAutomations',
  [InventoryCustomViewKey.inactiveUsers]: 'tableActionsAndFilters.inventoryCustomViewDetails.inactiveUsers',
  [InventoryCustomViewKey.automationUsesAiModel]:
    'tableActionsAndFilters.inventoryCustomViewDetails.automationUsesAiModel',
  [InventoryCustomViewKey.teamsEnvironments]: 'tableActionsAndFilters.inventoryCustomViewDetails.teamsEnvironments',
  [InventoryCustomViewKey.autonomousAgents]: 'tableActionsAndFilters.inventoryCustomViewDetails.autonomousAgents',
  [InventoryCustomViewKey.declarativeAgents]: 'tableActionsAndFilters.inventoryCustomViewDetails.declarativeAgents',
  [InventoryCustomViewKey.agentsUsingMcp]: 'tableActionsAndFilters.inventoryCustomViewDetails.agentsUsingMcp',
  [InventoryCustomViewKey.automationUsesWebhook]:
    'tableActionsAndFilters.inventoryCustomViewDetails.automationUsesWebhook',
  [InventoryCustomViewKey.automationUsesHttpStepsWithoutAuthentication]:
    'tableActionsAndFilters.inventoryCustomViewDetails.automationUsesHttpStepsWithoutAuthentication',
  [InventoryCustomViewKey.agentTriggers]: 'tableActionsAndFilters.inventoryCustomViewDetails.agentTriggers',
  [InventoryCustomViewKey.allBuilders]: 'tableActionsAndFilters.inventoryCustomViewDetails.allBuilders',
  [InventoryCustomViewKey.orgWideAccess]: 'tableActionsAndFilters.inventoryCustomViewDetails.orgWideAccess',
  [InventoryCustomViewKey.publicAccess]: 'tableActionsAndFilters.inventoryCustomViewDetails.publicAccess',
  [InventoryCustomViewKey.shadowAi]: 'tableActionsAndFilters.inventoryCustomViewDetails.shadowAi',
  [InventoryCustomViewKey.privilegedAgents]: 'tableActionsAndFilters.inventoryCustomViewDetails.privilegedAgents',
};
